import { render, staticRenderFns } from "./Puntos.vue?vue&type=template&id=1c0518c2&"
import script from "./Puntos.vue?vue&type=script&lang=ts&"
export * from "./Puntos.vue?vue&type=script&lang=ts&"
import style0 from "./Puntos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports